import script from "./message-plugin-layout-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin-layout-web.vue?vue&type=script&lang=ts&setup=true"

import "./message-plugin-layout-web.vue?vue&type=style&index=0&id=a6cdd7c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6cdd7c8"]])

export default __exports__